import { GlobalErrorHandler } from '../global-error-handler';
import { Injector, Injectable } from '@angular/core';

@Injectable()
export class BreckErrorHandler extends GlobalErrorHandler {
    constructor(public injector: Injector) {
        super(injector);
    }
}
